import { gql } from '@apollo/client';

export const GET_PICKUP_TASK_STATISTICS = gql`
  query GetPickupTaskStatistics($taskId: String!) {
    getPickupTaskStatistics(taskId: $taskId) {
      appointmentCount
      completedAppointments
      totalQuantity
      collectedQuantity
      estimatedDistance
      estimatedDuration
      actualDistance
      actualDuration
      loadRate
    }
  }
`;

export type GetPickupTaskStatisticsResponse = {
  getPickupTaskStatistics: {
    appointmentCount: number;
    completedAppointments: number;
    totalQuantity: number;
    collectedQuantity: number;
    estimatedDistance: number;
    estimatedDuration: number;
    actualDistance?: number;
    actualDuration?: number;
    loadRate: string;
  };
}; 